import SectionHeading from '@/pages/home/components/SectionHeading';
import { steps } from '@/mocks/home';

export default function StepsGuide() {
  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-secondary-50 border-y border-secondary-100">
      <SectionHeading
        index="06"
        eyebrow="How To Use"
        title="三步走通 · 从找入口到开始观看"
        desc="如果你是第一次来，照下面三步做就够了。流程很短，重点是第一步——先收藏。"
        align="center"
      />

      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 relative">
        {steps.map((step, index) => (
          <div key={step.id} className="relative">
            <div className="flex flex-col items-center text-center px-2">
              <span className="font-label text-xs tracking-[0.24em] text-secondary-600 mb-4">
                {step.no}
              </span>
              <span className="w-16 h-16 flex items-center justify-center rounded-full bg-background-50 border border-secondary-200 text-3xl text-secondary-600">
                <i className={step.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-5 font-heading font-bold text-lg text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                {step.desc}
              </p>
            </div>
            {index < steps.length - 1 && (
              <i
                className="hidden md:block absolute top-16 -right-4 ri-arrow-right-line text-2xl text-secondary-300"
                aria-hidden="true"
              ></i>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}